import { logErrorWrapper } from '../../../services/logWrapper';
import {
  RECEIVE_MONTH_DATA,
  SET_DIRECTNESS_FILTER_ANALYSIS,
} from '../helpers/constants/actionsConstants';
import logFunnelSearch from '../helpers/logging/funnelEventLogger';
import googleAnalyticsLogger from '../helpers/logging/googleAnalyticsLogger';
import { logOperationalEventWrapper } from '../helpers/logging/logOperationalEventWrapper';

import type { NextFn } from './types';
import type { Device } from '../../../services/contextAdaptor/types';
import type { LoggingAction } from '../helpers/logging/payload/types';
import type { Store } from 'redux';

export type FunnelEventType =
  | typeof SET_DIRECTNESS_FILTER_ANALYSIS
  | `${typeof RECEIVE_MONTH_DATA}_STARTED`;

const FUNNEL_EVENT_TRIGGERS: FunnelEventType[] = [
  SET_DIRECTNESS_FILTER_ANALYSIS,
  `${RECEIVE_MONTH_DATA}_STARTED`,
];

export const analyticsMiddleware =
  (
    store: Store,
    logGAEvent: (category: string, label: string, evtAction: string) => void,
    device?: Device,
  ) =>
  (next: NextFn) =>
  (action: LoggingAction) => {
    if (FUNNEL_EVENT_TRIGGERS.includes(action.type as FunnelEventType)) {
      logFunnelSearch(store.getState());
    }
    if ('meta' in action && action.meta) {
      if (action.meta.googleAnalyticsLogEvent) {
        googleAnalyticsLogger(action, store.getState(), false, logGAEvent);
      }
    }
    logOperationalEventWrapper(action, store.getState(), device);
    try {
      next(action);
    } catch (error) {
      const errorMessage = `error in executing next step of ${action.type}`;
      logErrorWrapper(
        error instanceof Error ? error : new Error(String(error)),
        {
          component: 'analyticsMiddleware',
          message: errorMessage,
        },
      );
      throw error;
    }
    // Logs for post action
    if ('meta' in action && action.meta) {
      if (action.meta.googleAnalyticsLogEvent) {
        googleAnalyticsLogger(action, store.getState(), true, logGAEvent);
      }
    }
  };
